import React, { LazyExoticComponent, Suspense } from 'react';

export const LazyImportComponent = (props: {
  lazyComponent: LazyExoticComponent<React.MemoExoticComponent<() => JSX.Element>>;
}) => {
  return (
    <Suspense fallback={<></>}>
      <props.lazyComponent />
    </Suspense>
  );
};